import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import Login from './components/Login';
import Home from './components/Home';
import Layout from './components/Layout';
import Users from './pages/setup/Users';
import Roles from './pages/setup/Roles';
import Permissions from './pages/setup/Permissions';
import MenuAdmin from './pages/setup/MenuAdmin';
import Products from './pages/setup/Products';
import ProductPacks from './pages/setup/ProductPacks';
import ProdIngredients from './pages/setup/ProdIngredients';
import ProductCombo from './pages/setup/ProductCombo';
import ApproveCustomers from './pages/online/ApproveCustomers';
import OnlineOrders from './pages/online/OnlineOrders';
import Referrals from './pages/online/Referrals';
import CommissionPayout from './pages/online/CommissionPayout';
import RazorpayReconcile from './pages/online/RazorpayReconcile';
import Offers from './pages/online/Offers';
import BankTransactions from './pages/bank/BankTransactions';
import StockLocations from './pages/stocks/Locations';
import MyStock from './pages/stocks/MyStock';
import ProductFlow from './pages/stocks/ProductFlow';
import SalesOrders from './pages/sales/SalesOrders';
import PurchaseOrders from './pages/purchase/PurchaseOrders';
import Expenses from './pages/expenses/Expenses';
import Profile from './pages/Profile';
import ChangePassword from './pages/ChangePassword';
import './App.css';

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          {/* Public Routes */}
          <Route path="/login" element={<Login />} />

          {/* Protected Routes with Layout */}
          <Route path="/home" element={<Layout><Home /></Layout>} />
          <Route path="/sales-orders" element={<Layout><SalesOrders /></Layout>} />
          <Route path="/purchase-orders" element={<Layout><PurchaseOrders /></Layout>} />
          <Route path="/expenses" element={<Layout><Expenses /></Layout>} />
          <Route path="/profile" element={<Layout><Profile /></Layout>} />
          <Route path="/change-password" element={<Layout><ChangePassword /></Layout>} />
          <Route path="/setup/users" element={<Layout><Users /></Layout>} />
          <Route path="/setup/roles" element={<Layout><Roles /></Layout>} />
          <Route path="/setup/permissions" element={<Layout><Permissions /></Layout>} />
          <Route path="/setup/menu-admin" element={<Layout><MenuAdmin /></Layout>} />
          <Route path="/setup/products" element={<Layout><Products /></Layout>} />
          <Route path="/setup/prod-ingredients" element={<Layout><ProdIngredients /></Layout>} />
          <Route path="/setup/product-combo" element={<Layout><ProductCombo /></Layout>} />
          <Route path="/setup/product-packs" element={<Layout><ProductPacks /></Layout>} />
          <Route path="/online/approve-customers" element={<Layout><ApproveCustomers /></Layout>} />
          <Route path="/online/orders" element={<Layout><OnlineOrders /></Layout>} />
          <Route path="/online/referrals" element={<Layout><Referrals /></Layout>} />
          <Route path="/online/commission-payout" element={<Layout><CommissionPayout /></Layout>} />
          <Route path="/online/reconcile" element={<Layout><RazorpayReconcile /></Layout>} />
          <Route path="/online/offers" element={<Layout><Offers /></Layout>} />
          <Route path="/bank/transactions" element={<Layout><BankTransactions /></Layout>} />
          <Route path="/stocks/locations" element={<Layout><StockLocations /></Layout>} />
          <Route path="/stocks/my-stock"     element={<Layout><MyStock /></Layout>} />
          <Route path="/stocks/product-flow" element={<Layout><ProductFlow /></Layout>} />

          {/* Default Route */}
          <Route path="/" element={<Navigate to="/login" replace />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
